module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!./Tank.js"));
	}, "Tank");
}